import type { PaymentBrowserInfoModel } from '@supply-mover-2-0/shared';

/**
 * Snapshot the shopper's browser environment for gateway risk scoring
 * (PD-15229). Adyen's Uplift program uses these signals to improve
 * authorization rates, so every browser-initiated payment submission attaches
 * this to its request.
 *
 * All values come from ambient browser APIs — nothing is asked of the user.
 * `acceptHeader` cannot be read from JavaScript; Adyen documents a wildcard
 * as the accepted fallback for API-only integrations.
 *
 * Returns null outside a browser (SSR/tests) so callers can pass the result
 * through optional fields without guarding.
 */
export const collectBrowserInfo = (): PaymentBrowserInfoModel | null => {
	if (typeof window === 'undefined' || typeof navigator === 'undefined') {
		return null;
	}

	return {
		acceptHeader: '*/*',
		colorDepth: window.screen.colorDepth,
		javaEnabled: false,
		language: navigator.language,
		screenHeight: window.screen.height,
		screenWidth: window.screen.width,
		timeZoneOffset: new Date().getTimezoneOffset(),
		userAgent: navigator.userAgent,
	};
};
